module.exports = __webpack_public_path__ + "img/iterable_logo.bf06e3f5.png";